import { gql } from '@apollo/client';

export const EPIC_FIELDS_FRAGMENT = gql`
    fragment EpicFields on Epic {
        Name
        EpicId
        EpicNbr
        Created
        Updated
        Description
        Target
        Budget
        StartDate
        EndDate
        DataOwner
        Secret
        EpicType {
            EpicTypeId
            Name
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        EpicUsers {
            User {
                UserState
                Firstname
                Lastname
                Phone
                Email
                UserId
                OwnOrganization {
                    OrganizationId
                    Name
                }
            }
            AccessUserType {
                ... on UserEpicRoleType {
                    UserEpicRoleTypeId
                    Name
                }
            }
        }
        Tasks {
            TaskId
            Location {
                LocationId
            }
            TaskStatus {
                Name
            }
        }
        EpicStatus {
            EpicStatusId
            Name
        }
        Phase {
            EpicPhaseTypeId
            Name
            Created
            Updated
        }
        CoordinateSystemType {
            Name
            CoordinateSystemTypeId
            DatumCode
        }
        HeightSystemType {
            Name
            HeightSystemTypeId
        }
        WorkPackage {
            WorkPackageId
        }
        EpicSummary {
            TaskDone
            TaskTotal
            WorkPackageDone
            WorkPackageTotal
            TaskSummary {
                TaskType {
                    Name
                    Abbr
                    TaskGroup
                }
                Open
                Assigned
                Resourced
                Ongoing
                Done
                Cancelled
                Failed
                Paused
                Total
                TaskStatus {
                    TaskStatusId
                    Name
                }
            }
        }
    }
`;

export const EPIC_USERS_FIELDS_FRAGMENT = gql`
    fragment EpicUserFields on Epic {
        EpicId
        EpicUsers {
            User {
                Firstname
                Lastname
                UserId
                Phone
                Email
                Abbr
                Access {
                    Read
                    Update
                    Delete
                    Create
                }
                Title
                UserState
                ProjectCount
                Created
                OwnOrganization {
                    Name
                    OrganizationId
                }
                LastUpdate
                OrganizationAdmin
                SystemAdmin
                LastLogin
            }
            AccessUserType {
                ... on UserEpicRoleType {
                    UserEpicRoleTypeId
                    Name
                }
            }
        }
    }
`;
